import { createFileRoute } from "@tanstack/react-router";
import { BaggersLayout } from "#/features/baggers/components/baggers-layout";
import { tradeMetaQueryOptions } from "#/features/trade/hooks/use-trade-market";

export const Route = createFileRoute("/baggers")({
	// SSR: 마켓 meta(이름·가격·거래량)만 채워 랭킹 50행이 서버 HTML에 실린다.
	// ponytail: 캔들(50코인×365봉)은 의도적으로 미프리페치 — 배수 컬럼은 클라이언트가 채운다.
	// 행 이름/엔티티가 SEO 페이로드; 배수까지 SSR하려면 백엔드 프리컴퓨트로 승격할 것.
	loader: ({ context: { queryClient } }) =>
		queryClient.prefetchQuery(tradeMetaQueryOptions(queryClient)),
	component: BaggersLayout,
});
